/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2023-03-17 10:27:55
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-06-17 10:44:50
 */
import { Avatar, Button, Dropdown, Form, Input, message, Modal, Space } from "antd"
import type { MenuProps } from 'antd';
import styles from './index.less'
import { history, useLocation, styled } from '@umijs/max'
// import { ReactComponent as UserIcon } from '@/assets/user-icon.svg'
// import { ReactComponent as OutIcon } from '@/assets/outIcon.svg'
// import { ReactComponent as EditIcon } from '@/assets/edit.svg'
// import { ReactComponent as SuccessIcon } from '@/assets/success.svg'
import { storageUserName, storeKeyCurrentUser } from "@/utils/enum"

import { TipsMoadlConfig } from "../TipsModal";
import { useModel } from "@umijs/max";
import { useMemo, useState } from "react";
import { useRequest } from "@umijs/max";
import { userResetApi } from "@/services/login";
// import { setPassword } from "@/services/login";
const PasswordReviseSuccess = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`
const Index = () => {
    const [form] = Form.useForm()
    const [passwordShow, setPasswordShow] = useState(false)
    const [reviseSuccess, setReviseSuccess] = useState(false)
    const { userInfo } = useModel('global')

    const location = useLocation()
    const { run: changePassword } = useRequest(userResetApi, {
        manual: true,
        onSuccess: (res) => {
            signAgain()
        }
    })

    const showConfirm = () => {
        TipsMoadlConfig({
            title: '退出系统',
            content: <p style={{ margin: '30px 0' }}>确认退出系统登录?</p>,
            okText: '确定',
            onOk: () => {
                signAgain()
            },
        })
    };
    const formSubmit = (data: any) => {
        const { oldPassword, newPassword } = data
        changePassword({ newPassword, oldPassword, username: userInfo?.username })
    }
    const dropdownItems: MenuProps['items'] = [
        {
            label: (
                <div className={styles.out} onClick={() => setPasswordShow(true)}>
                    修改密码
                </div>
            ),
            key: '0',
        },
        {
            label: (
                <div className={styles.out} onClick={showConfirm}>
                    退出登录
                </div>
            ),
            key: '1',
        },
    ];

    const signAgain = () => {
        localStorage.clear()
        history.push('/login')
    }
    return <div className={styles.right}>
        <Dropdown overlayClassName={styles.headDown} menu={{ items: dropdownItems }}  >
            <div className={styles.close} >
                管理员
            </div>
        </Dropdown>

        <Modal
            width={700}
            open={passwordShow}
            title='修改密码'
            // okText='确认修改'
            onCancel={() => { setPasswordShow(false) }}
            onOk={() => form.submit()}
            destroyOnClose
            styles={{
                body: {
                    height: 200,
                    paddingTop: 20
                }
            }}
        >
            <Form
                form={form}
                onFinish={formSubmit} labelCol={{ span: 4 }} wrapperCol={{ offset: 1, span: 16 }} preserve={false}
            >
                <Form.Item label='用户名' >
                    {userInfo?.username}
                </Form.Item>
                <Form.Item label='新密码' name='newPassword' rules={[{ required: true, message: '请输入密码' }, { min: 6, max: 16 }]} hasFeedback>
                    <Input.Password placeholder="长度限制：6-16个字符" />
                </Form.Item>
                <Form.Item
                    label='确认密码'
                    name='oldPassword'
                    dependencies={['newPassword']}
                    rules={[
                        {
                            required: true,
                            message: '请确认密码'
                        },
                        {
                            min: 6,
                            max: 16,
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('两次输入的密码不一致!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="长度限制：6-16个字符" />
                </Form.Item>
            </Form>

        </Modal>
    </div>
}
export default Index